<template>
  <div class="cover-b" v-if="visiable">
    <div class="promotion" v-if="student.upgrade.type === 'grade'">
      <p class="promotion-texttop f20 white">
        恭喜<span class="f20 white" :title="student.name">{{ student.name }}</span
        >顺利进入
      </p>
      <p class="promotion-name f20">{{ student.school }}</p>
      <p class="promotion-text f20">{{ student.grade + student.clazz }}</p>
      <div class="promotion-btnBox">
        <button class="promotion-btn btn btn-l btn-green" @click="confirm">
          知道了
        </button>
      </div>
      <p class="promotion-cname f12 grey9">若有疑问，请联系客服400-018-9011</p>
    </div>
    <div class="preiod-promotion" v-else>
      <div class="preiod-promotion-content">
        <h5>
          <span>{{ student.name }}</span
          >同学
        </h5>
        <h5>祝贺你{{ student.upgrade.periodName }}毕业啦！</h5>
        <p>{{ student.upgrade.createTime }}</p>
        <p>驰声大学听说教学平台与你相遇</p>
        <p>到如今</p>
        <p>
          已陪伴你度过了<span>{{ student.upgrade.days }}</span
          >天！
        </p>
        <p>一份耕耘，一份收获</p>
        <p>一路见证你奋斗的足迹</p>
        <p>期待我们继续携手，共同成长！</p>
      </div>
      <div class="preiod-promotion-btnBox">
        <km-button size="higher" :isBorder="true" @click="cancel">
          暂时不加入
        </km-button>
        <km-button size="higher" :isBack="true" @click="confirm">
          加入新班级
        </km-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visiable: false,
      type: 2
    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      this.visiable = true
    })
  },
  methods: {
    close() {
      this.$destroy()
      this.$el.parentElement.removeChild(this.$el)
    },
    confirm() {
      this.resolve()
      this.close()
    },
    cancel() {
      this.reject()
      this.close()
    },
    handle() {
      this.closeWithReject ? this.close() : this.cancel()
    }
  }
}
</script>

<style lang="less" scoped>
.promotion {
  width: 350px;
  height: 400px;
  background-image: url(/static/images/stu/index/bg_newterm.png);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  i {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  p {
    line-height: 24px;
  }

  a,
  button {
    width: 120px;
  }

  .promotion-texttop {
    margin-top: 104px;
    display: flex;
    align-items: center;
  }

  .promotion-texttop span {
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }

  .promotion-name {
    margin-top: 64px;
    margin-bottom: 10px;
  }

  .promotion-btn {
    margin-top: 50px;
    margin-bottom: 20px;
  }
}

.preiod-promotion {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 400px;
  height: 520px;
  padding-top: 158px;
  background: #fff url(/static/images/stu/index/bg_newpreiod.png) no-repeat top center;
  box-sizing: border-box;
  border-radius: 10px;

  .preiod-promotion-content {
    flex: 1;
    padding: 20px;
    line-height: 28px;
    text-align: center;

    h5 {
      font-size: 16px;
      color: #333;
    }

    p {
      margin: 0;
      padding: 0;
      color: #666;
    }

    span {
      color: #21bd73;
    }
  }

  .preiod-promotion-btnBox {
    display: flex;
    justify-content: center;
    height: 40px;
    padding-bottom: 30px;
    box-sizing: content-box;

    .km-button {
      width: 120px;
      margin: 0 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/ui/components/promoteDialog/App.vue